import { resetFilters } from "../Redux/filtersSlice";
import { getSavedParksSelector, toggleSavedPark } from "../Redux/savedParksSlice";

// This is for business logic, please put analytics in analyticsMiddleware
export const middleware = (store) => (next) => (action) => {
  if (!action || !action.type) {
    return next(action);
  }

  const result = next(action);

  switch (action.type) {
    case toggleSavedPark.type: {
      const state = store.getState();
      const savedParks = getSavedParksSelector(state);

      if (savedParks.length === 0) {
        store.dispatch(resetFilters());
      }
      break;
    }

    default: {
      break;
    }
  }

  return result;
};
